import { useEffect, useState } from 'react';

/**
 * KioskHeader - Standardized header for all kiosk pages
 * Uses the approved ParkWise logo asset
 */
export function KioskHeader({ showDateTime = true, showProgress = false, currentStep = 1 }) {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    if (!showDateTime) return;
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, [showDateTime]);

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: true }).toUpperCase();
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  };

  return (
    <header 
      style={{
        width: '100%',
        height: '100px',
        backgroundColor: '#0d2137',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 40px',
        flexShrink: 0,
        borderBottom: '3px solid #1e3a5f'
      }}
    >
      {/* Approved ParkWise Logo Asset */}
      <img 
        src="/parkwise-logo.png" 
        alt="ParkWise"
        style={{ 
          height: '70px', 
          objectFit: 'contain'
        }}
      />

      {/* Progress Steps (optional) */}
      {showProgress && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {[1, 2, 3].map((step, i) => (
            <div key={step} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                backgroundColor: step <= currentStep ? '#22c55e' : 'rgba(255,255,255,0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: step <= currentStep ? 'white' : 'rgba(255,255,255,0.4)',
                fontWeight: 'bold',
                fontSize: '22px',
                fontFamily: 'Outfit, sans-serif'
              }}>{step}</div>
              {i < 2 && (
                <div style={{ 
                  width: '40px', 
                  height: '4px', 
                  backgroundColor: step < currentStep ? '#22c55e' : 'rgba(255,255,255,0.15)', 
                  borderRadius: '2px' 
                }} />
              )}
            </div>
          ))}
        </div>
      )}

      {/* Date/Time */}
      {showDateTime && (
        <div style={{ textAlign: 'right' }}>
          <p style={{ fontSize: '38px', fontWeight: '700', color: 'white', margin: 0, lineHeight: 1, fontFamily: 'Outfit, sans-serif' }}>
            {formatTime(currentTime)}
          </p>
          <p style={{ fontSize: '15px', color: 'rgba(255,255,255,0.6)', margin: '4px 0 0 0' }}>
            {formatDate(currentTime)}
          </p>
        </div>
      )}
    </header>
  );
}

export default KioskHeader;
